'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRoute = exports.UPDATE_ROUTE = exports.delRoute = exports.DEL_ROUTE = exports.addRoutes = exports.ADD_ROUTES = exports.addRoute = exports.ADD_ROUTE = undefined;

var _unary2 = require('lodash/unary');

var _unary3 = _interopRequireDefault(_unary2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _flip2 = require('lodash/flip');

var _flip3 = _interopRequireDefault(_flip2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.addRoutesPayload = addRoutesPayload;

var _capeRedux = require('cape-redux');

var _capeSelect = require('cape-select');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Make and save new routes.


var ADD_ROUTE = exports.ADD_ROUTE = 'locInfo/ADD_ROUTE';
var addRouteMenu = (0, _capeSelect.structuredSelector)({
  id: _utils.getRouteId,
  path: _utils.getRoutePath
}); // @id is a machine readable string for the route.
// @path is a path string. See url-pattern module for possible options.
// @props object
//  `options` @see https://github.com/snd/url-pattern#customize-the-pattern-syntax
//  `path`
//  `position`.

function addRoutePayload(arg1) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if ((0, _isPlainObject3.default)(arg1)) return addRouteMenu(arg1);
  return _extends({}, props, {
    id: (0, _utils.idString)(arg1),
    path: path
  });
}

var addRoute = exports.addRoute = (0, _capeRedux.createSimpleAction)(ADD_ROUTE, addRoutePayload); // addRoutes

var ADD_ROUTES = exports.ADD_ROUTES = 'locInfo/ADD_ROUTES'; // When you need an event simpler way to create routes.
// Key of object is the route id. Value is the route path template string.

function addRoutesPayload(routeObject) {
  if ((0, _isArray3.default)(routeObject)) {
    return (0, _map3.default)(routeObject, (0, _unary3.default)(addRoutePayload));
  }

  return (0, _map3.default)(routeObject, (0, _ary3.default)((0, _flip3.default)(addRoutePayload), 2));
}

var addRoutes = exports.addRoutes = (0, _capeRedux.createSimpleAction)(ADD_ROUTES, addRoutesPayload); // deleteRoute

var DEL_ROUTE = exports.DEL_ROUTE = 'locInfo/DEL_ROUTE';
var delRoute = exports.delRoute = (0, _capeRedux.createSimpleAction)(DEL_ROUTE, _utils.idString);
var UPDATE_ROUTE = exports.UPDATE_ROUTE = 'locInfo/UPDATE_ROUTE';
var updateRoute = exports.updateRoute = (0, _capeRedux.createSimpleAction)(UPDATE_ROUTE);